function UserInfoHeader(renderer) {
  function zeroPad(number) {
    return number < 10 ? '0' + number : '' + number;
  }

  this.show = function (session) {
    let now = new Date()

    $('#user-info').html(renderer.render('user-info-template', {
      user: session.user,
      currentTime: zeroPad(now.getHours()) + ':' + zeroPad(now.getMinutes()) + ' ' + zeroPad(now.getDate()) + '.' + zeroPad(1 + now.getMonth())
    })).fadeIn()
  }
}